import React, {useState, Fragment, useEffect} from 'react';
import { Card, CardContent, } from '@mui/material';
import { NavigateNext } from '@mui/icons-material';
import {useDispatch, useSelector,} from 'react-redux';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import { setearDatosAlStore } from 'store/actions/customAction';
import Formulario from 'components/formulario';
import { nombreDeAcciones } from 'constantes/nombreDeAcciones';

const DatosDelCanal = ({activeStep, numberStep, handleClose, datosDelCanal}) => {
    const dispatch = useDispatch();
    const {tarifarioYDisponibilidad} = useSelector( ({nuevoTarifario}) => nuevoTarifario);

    const [responseData, setResponseData] = useState({ errorType: 'error', messageType: '', openResponse: false, });
    const { nombreDelCanal, numeroDelCanal, logoCanal, descripcionCanal, correoElectronico, diasDeAnticipacion, comentarioEspecificaciones, estaRegistrandoCanal } = datosDelCanal;

    useEffect(() => {
        validarDisponibilidad()
    }, [])

    const validarDisponibilidad = () => {
        const copiaElements = Object.assign({}, elements);
        if(tarifarioYDisponibilidad?.disponibilidades?.length > 0) {
            copiaElements.alertaDisponibilidad.showAlertForm = true
            copiaElements.estaRegistrandoCanal.disabled = true;
        } else {
            copiaElements.alertaDisponibilidad.showAlertForm = false
            copiaElements.estaRegistrandoCanal.disabled = false
        }

        setElements(copiaElements);
    }

    const [elements, setElements] = React.useState({
        tituloDatosDelCanal:{
            idelement: "tituloDatosDelCanal", title:'Datos del canal', position:"center", elementType:'titulo', showTitleForm: true, name: "tituloDatosDelCanal", value: "", isError:false,
        },
        nombreDelCanal: {
            idelement: "nombreDelCanal",  value: nombreDelCanal, label: "Nombre del Canal *", pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.#_“”()-*_/@]{4,100}$", validators: ['required'], errorMessages:['El campo es requerido, sin espacios al inicio y final'], isError:false, elementType:'texto', name:"nombreDelCanal", 'disabled': false, width: '33%'
        },
        numeroDelCanal: {
            idelement: "numeroDelCanal",  value: numeroDelCanal, label: "Número del canal *", pattern:"^[0-9]{1,5}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"numeroDelCanal", 'disabled': false, width: '33%'
        },
        logoCanal:{
            idelement: "logoCanal", value: logoCanal, label: "LOGO", validators: {required: true,  size: "8 MB",}, errorMessages: 'Por favor debe adjuntar lo solicitado', isError:false, elementType:'archivo','disabled':false, name:"logoCanal", fileWidth: true, src: '', multiple: false, accept:".png, .jpg", showInMovil: true, width: '33%', type: "file"
        },
        descripcionCanal:{
            idelement: "descripcionCanal", value: descripcionCanal, label: `Descripción del canal`, pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.!#$%&<>~^'=?¿+:;_“”()-*_/@]{4,2000}$", validators: ['required'],
            errorMessages:['El campo es requerido'], isError:false, elementType:'areaTexto','disabled':false, fullWidth: true, name: "descripcionCanal", width: '100%'
        },

        tituloEspecificaciones:{
            idelement: "tituloEspecificaciones", title:'Especificaciones Técnicas', position:"center", elementType:'titulo', showTitleForm: true,  name: "tituloEspecificaciones", value: "", isError:false,
        },
        correoElectronico: {
          idelement: "correoElectronico", value: correoElectronico, label: "Correo electrónico para recepción de materiales *", pattern:"^[\\wA-Z0-9._%+-]+@[\\wA-Z0-9.-]+\\.\\w{2,4}$", validators: ['required'], errorMessages:['Ingrese un correo válido'], isError:false, elementType:'texto', name:"correoElectronico", width: "50%"
        },
        diasDeAnticipacion: {
            idelement: "diasDeAnticipacion",  value: diasDeAnticipacion, label: "Días de anticipación para entregar el material a pautar *", pattern:"^[0-9]{1,5}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"diasDeAnticipacion", 'disabled': false, width: "50%"
        },
        comentarioEspecificaciones:{
            idelement: "comentarioEspecificaciones", value: comentarioEspecificaciones, label: `Especificaciones técnicas del material`, pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.!#$%&<>~^'=?¿+:;_“”()-*_/@]{4,2000}$", validators: ['required'], errorMessages:['El campo es requerido'], isError:false, elementType:'areaTexto','disabled':false, fullWidth: true, name: "comentarioEspecificaciones", width: '100%'
        },
        tituloRegistroPrograma:{
            idelement: "tituloRegistroPrograma", title:'Registro de programas que se transmite en un canal tercero', position:"center", elementType:'titulo', showTitleForm: true, name: "tituloRegistroPrograma", value: "", isError:false,
        },
        alertaDisponibilidad:{
            idelement: "alertaDisponibilidad", mensaje:'PARA MODIFICAR ESTE CAMPO, DEBE ELIMINAR EL LISTADO DE DISPONIBILIDADES REGISTRADAS', elementType:'alerta', showAlertForm: false, name: "alertaDisponibilidad", value: "", isError:false, severity: 'error'
        },
        estaRegistrandoCanal:{
          idelement: "estaRegistrandoCanal", value: estaRegistrandoCanal, label: "¿Esta registrando programas que se transmite en un canal tercero? *", isError:false, elementType:'radio', errorMessages:['Debe marcar una opción'], options : [ { value: 1, label: 'SI' }, { value: 2, label: 'NO' }], 'disabled':false, isRequired: true,
        },
        acciones:{
            idelement: "acciones", title:'Acciones', position:"center", elementType:'titulo', showTitleForm: true, name: "acciones", value: "", isError:false,
        },
    });

    const cancelarAccion = () => {
        dispatch(setearDatosAlStore({ dispatchAction : nombreDeAcciones.LIMPIAR_TODO_EL_REDUCER}));
        handleClose(true);
    };

    const siguientePaso = async (dataForm) => {
        await dispatch(setearDatosAlStore({
            dispatchAction : nombreDeAcciones.SETEAR_DATOS_DEL_CANAL,
            data: {
                datosDelCanal: dataForm,
                activeStep : activeStep + 1,
                numberStep : numberStep + 1
            }
        }));
    }

    const [buttonList]= React.useState({
        "siguientePaso":{"label":"Siguiente", "icon": <NavigateNext />, "callback":siguientePaso,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
                isCancel: false,
        },
        "cancelar":{"label":"Cancelar", "icon": <NavigateNext />,"callback":cancelarAccion,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
                isCancel: true,
        },
    });

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const changeDataResponse = (errorType, messageType, openResponse = false) => {
        setResponseData({errorType,messageType,openResponse,})
    };

    const { errorType, messageType, openResponse} = responseData;

    return (
        <Fragment>
            <AlertaDeRespuesta type={errorType} content={messageType} open={openResponse} handClose={handClose}/>
            <Card>
                <CardContent>
                    <Formulario
                        elements={elements}
                        buttonList={buttonList}
                    />
                </CardContent>
            </Card>
        </Fragment>
    );
}

export default DatosDelCanal;